import { useTranslation } from 'react-i18next';

const featureItems = [
  { key: 'about.feature1', icon: 'ri-refresh-line' },
  { key: 'about.feature2', icon: 'ri-price-tag-3-line' },
  { key: 'about.feature3', icon: 'ri-footprint-line' },
  { key: 'about.feature4', icon: 'ri-link' },
] as const;

const statItems = [
  { value: 'about.stat1', label: 'about.stat1Label' },
  { value: 'about.stat2', label: 'about.stat2Label' },
  { value: 'about.stat3', label: 'about.stat3Label' },
  { value: 'about.stat4', label: 'about.stat4Label' },
] as const;

export default function AboutSection() {
  const { t } = useTranslation('home');

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-accent-50">
      <div className="max-w-5xl mx-auto">
        {/* Tag pill */}
        <span className="inline-block px-5 py-2 bg-background-50 text-foreground-900 rounded-full text-sm font-medium mb-8">
          {t('about.tag')}
        </span>

        {/* Title */}
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-extrabold text-foreground-950 leading-tight mb-6">
          {t('about.title1')}
          <br />
          {t('about.title2')}
        </h2>

        {/* Description */}
        <p className="text-sm md:text-base text-foreground-700 max-w-2xl leading-relaxed mb-12">
          {t('about.desc')}
        </p>

        {/* Image + Features row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* Left: Product image */}
          <div className="rounded-2xl overflow-hidden">
            <div className="aspect-[4/3] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20streetwear%20items%20and%20sneakers%20beautifully%20displayed%20on%20wooden%20shelf%20against%20warm%20beige%20wall%2C%20lifestyle%20product%20photography%2C%20soft%20natural%20window%20light%20from%20side%2C%20cozy%20boutique%20atmosphere%2C%20modern%20urban%20aesthetic%2C%20editorial%20composition%2C%20warm%20inviting%20tones&width=800&height=600&seq=about-v2-image&orientation=landscape"
                alt="CSSBuy Spreadsheet Products Collection"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: Features list */}
          <div className="flex flex-col justify-center gap-5">
            {featureItems.map((item) => (
              <div key={item.key} className="flex items-start gap-4 bg-background-50 rounded-xl p-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-primary-600 text-sm`} />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-foreground-900 mb-0.5">{t(item.key)}</p>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.key === 'about.feature1' && 'Novos produtos adicionados todos os dias'}
                    {item.key === 'about.feature2' && 'Preços direto da fonte, sem intermediários'}
                    {item.key === 'about.feature3' && 'Nike, Adidas, Jordan e muito mais'}
                    {item.key === 'about.feature4' && 'Um clique até o produto desejado'}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
          {statItems.map((stat) => (
            <div key={stat.value} className="text-left bg-background-50 rounded-xl p-5">
              <p className="text-3xl md:text-4xl font-heading font-extrabold text-primary-600">
                {t(stat.value)}
              </p>
              <p className="text-sm text-foreground-600 mt-1">
                {t(stat.label)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}